import { GenIcon } from 'react-icons';
export const MdCurrencyFlagTry = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 90 90',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip0_try)' },
            child: [
                // Red background (circular shape)
                {
                    tag: 'path',
                    attr: {
                        d: 'M87.429 30C81.254 12.534 64.611 0.015 45.034 0h-0.068C25.389 0.015 8.745 12.534 2.571 30C0.911 34.693 0 39.739 0 45c0 5.261 0.912 10.308 2.571 15C8.75 77.476 25.408 90 45 90s36.25-12.524 42.429-30C89.088 55.307 90 50.261 90 45C90 39.739 89.089 34.693 87.429 30z',
                        fill: '#E30A17',
                    },
                    child: [],
                },
                // White crescent moon
                {
                    tag: 'path',
                    attr: {
                        d: 'M42.102 62.332c-9.739 0-17.634-7.76-17.634-17.333s7.895-17.333 17.634-17.333c5.241 0 9.934 2.26 13.164 5.828c-3.899-6.102-10.803-10.161-18.675-10.161c-12.174 0-22.042 9.7-22.042 21.667s9.868 21.667 22.042 21.667c7.875 0 14.781-4.062 18.679-10.168C52.041 60.07 47.346 62.332 42.102 62.332z',
                        fill: '#FFFFFF',
                    },
                    child: [],
                },
                // White star
                {
                    tag: 'path',
                    attr: {
                        d: 'M62.926 34.878l-0.178 8.009l-7.472 2.029l7.366 2.623l-0.178 7.345l4.804-5.736l7.259 2.518l-4.199-6.155l5.124-6.121l-7.864 2.168L62.926 34.878L62.926 34.878z',
                        fill: '#FFFFFF',
                    },
                    child: [],
                },
                // White border stroke
                {
                    tag: 'circle',
                    attr: {
                        cx: '45',
                        cy: '45',
                        r: '44',
                        stroke: 'white',
                        strokeWidth: '1',
                        fill: 'none',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_try' },
                    child: [
                        {
                            tag: 'circle',
                            attr: {
                                cx: '45',
                                cy: '45',
                                r: '45',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
